import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=497b891c&scoped=true&lang=pug&"
import script from "./TagForm.vue?vue&type=script&lang=js&"
export * from "./TagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b891c",
  null
  
)

export default component.exports